module.exports = __webpack_public_path__ + "static/media/S1-9-Nazzbrok-cod9.bf4f6bb9.png";